import React, { useState } from "react";
import api from "../../api";
import { useNavigate } from "react-router-dom";

export default function SupportCreate() {
  const navigate = useNavigate(); // ✅ same as before

  const [title, setTitle] = useState("");
  const [description, setDescription] = useState("");
  const [priority, setPriority] = useState(1);
  const [loading, setLoading] = useState(false);

  const submitTicket = async () => {
    if (!title.trim() || !description.trim()) {
      alert("❗ Please fill all fields");
      return;
    }

    try {
      setLoading(true);

      await api.post("/support/student/ticket", {
        title: title.trim(),
        description: description.trim(),
        priority: Number(priority),
      });

      alert("✅ Support ticket submitted successfully");

      setTitle("");
      setDescription("");
      setPriority(1);

      // ✅ correct redirect
      navigate("/user/dashboard", { replace: true });
    } catch (err) {
      console.error("Support submit failed:", err);
      alert("❌ Failed to submit support ticket");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div style={pageStyle}>
      <div style={overlayStyle}>
        <div style={cardStyle}>
          {/* ================= HEADER ================= */}
          <div style={headerStyle}>
            <img src="/logo.png" alt="EduAt10" style={logoStyle} />
            <h2 style={titleStyle}>🆘 Support</h2>
          </div>

          {/* ================= FORM ================= */}
          <input
            placeholder="Problem Title"
            value={title}
            onChange={(e) => setTitle(e.target.value)}
            style={inputStyle}
          />

          <textarea
            placeholder="Describe your problem"
            value={description}
            onChange={(e) => setDescription(e.target.value)}
            style={{ ...inputStyle, minHeight: 120 }}
            rows={5}
          />

          <select
            value={priority}
            onChange={(e) => setPriority(Number(e.target.value))}
            style={inputStyle}
          >
            <option value={1}>Payment Issue (24h)</option>
            <option value={2}>Scholarship / Mega Exam (24h)</option>
            <option value={3}>Study / Practice (48h)</option>
            <option value={4}>Other Issue (72h)</option>
          </select>

          <button
            onClick={submitTicket}
            disabled={loading}
            style={submitBtn}
          >
            {loading ? "Submitting..." : "Submit Ticket"}
          </button>

          {/* ================= BACK ================= */}
          <button
            onClick={() => navigate("/user/dashboard")}
            style={backBtn}
          >
            ← Back to Dashboard
          </button>
        </div>
      </div>
    </div>
  );
}

/* ================= BACKGROUND ================= */
const pageStyle = {
  minHeight: "100vh",
  backgroundImage: "url('/eduat10-bg.png')",
  backgroundSize: "cover",
  backgroundPosition: "center",
};

const overlayStyle = {
  minHeight: "100vh",
  backgroundColor: "rgba(0,0,0,0.25)",
  padding: 20,
};

/* ================= CARD ================= */
const cardStyle = {
  maxWidth: 600,
  margin: "auto",
  background: "rgba(255,255,255,0.95)",
  borderRadius: 16,
  padding: 30,
};

/* ================= HEADER ================= */
const headerStyle = {
  display: "flex",
  flexDirection: "column",
  alignItems: "center",
  gap: 8,
  marginBottom: 20,
};

const logoStyle = {
  width: 120,
};

const titleStyle = {
  fontSize: 20,
  fontWeight: 800,
};

/* ================= FORM ================= */
const inputStyle = {
  width: "100%",
  padding: 12,
  marginBottom: 12,
  borderRadius: 8,
  border: "1px solid #d1d5db",
  fontSize: 14,
};

/* ================= BUTTONS ================= */
const submitBtn = {
  width: "100%",
  padding: "10px 16px",
  background: "#2563eb",
  color: "white",
  border: "none",
  borderRadius: 8,
  cursor: "pointer",
  fontWeight: 600,
};

const backBtn = {
  marginTop: 12,
  width: "100%",
  padding: "10px 16px",
  background: "#e2e8f0",
  border: "none",
  borderRadius: 8,
  cursor: "pointer",
};
